import React from "react";
import cx from "classnames";
import styles from "./Facilities.module.scss";
import MainItem from "./MainItem";
import ClientWrapper from "@containers/ClientWrapper";
import { formatTimeDisplay } from "@utils/dateFormatter";
import _ from "lodash";

export default function Facilities({ data }: any) {
  const facilities: any = _.map(data, (item) => ({
    key: _.get(item, "tabKey"),
    image: _.get(item, "image"),
    images: _.compact([_.get(item, "image"), ..._.get(item, "images")]),
    title: _.get(item, "title"),
    content: _.get(item, "description"),
    shouldEnquire: false,
    moreInfo: {
      time: `${formatTimeDisplay(
        _.get(item, "openTime"),
        "HH:mm:ss"
      )} - ${formatTimeDisplay(_.get(item, "closeTime"), "HH:mm:ss")}`,
      phone: _.get(item, "phone"),
      floor: _.get(item, "location"),
    },
  }));
  return (
    <ClientWrapper>
      <div data-scroll-section className={cx(styles.section)}>
        {_.map(facilities, (item, index) => (
          <MainItem item={item} key={index} />
        ))}
      </div>
    </ClientWrapper>
  );
}
